/* eslint-disable max-len */

export default {
  clabe: 'Ingresa la CLABE',
  bank: 'Banco',
};
